/**
 * Vertragsmanagement API
 * REST-Api für das Conergos Vertragsmanagement Tool.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: marius.junak@scorpius-forge.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { DestroyRef, inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Configuration } from '../configuration';
import { CreateOrUpdateUserDto } from '@bo-client/shared/models/createOrUpdateUserDto';
import { DeleteUserDto } from '@bo-client/shared/models/deleteUserDto';
import { UpdatePasswordDto } from '@bo-client/shared/models/updatePasswordDto';
import { UserDto } from '@bo-client/shared/models/userDto';
import { ConfigService } from '@bo-client/config/config.service';
import { uri } from '@bo-client/shared/constants/uri';
import { HttpHapService } from '../http/http-hap.service';
import { EntityService } from '@bo-client/shared/dynamic-search-serverside/entity-service';
import { AuthorizationService } from '@bo-client/core/authorization/authorization.service';
import { switchMap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class UserService implements EntityService {
  private authorizationService = inject(AuthorizationService);
  private destroyRef = inject(DestroyRef);

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    protected httpHapClient: HttpHapService,
    @Optional() configuration: Configuration,
    private configService: ConfigService
  ) {}
  baseUrl: string;

  navigateToCreatePage(params: any) {
    throw new Error('Method not implemented.');
  }
  navigateToEditPage(id: any) {
    throw new Error('Method not implemented.');
  }

  loadData(
    tenant: string,
    environment: string,
    page: number,
    size: number,
    filterModel: any,
    columnState: any[]
  ): Observable<{
    content: any[];
    totalElements: number;
  }> {
    const result = columnState
      .filter((item) => item.sort)
      .map((item) => ({ colId: item.colId, sort: item.sort }));

    const dummyFilterModel = {
      filterModel: filterModel,
      sortModel: result
    };

    return this.httpHapClient.postTyped<{
      content: any[];
      totalElements: number;
    }>(dummyFilterModel, `/users/filter/v2?page=${page}&size=${size}`);
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * createUser
   *
   * @param dto dto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createUser(
    dto: CreateOrUpdateUserDto,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<UserDto>;
  public createUser(
    dto: CreateOrUpdateUserDto,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<UserDto>>;
  public createUser(
    dto: CreateOrUpdateUserDto,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<UserDto>>;
  public createUser(
    dto: CreateOrUpdateUserDto,
    observe: any = 'body',
    reportProgress = false
  ): Observable<any> {
    if (dto === null || dto === undefined) {
      throw new Error('Required parameter dto was null or undefined when calling createUser.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<UserDto>(`${this.configService.getSettings('serverUrl')}/users/`, dto, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * deleteUser
   *
   * @param dto dto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteUser(dto: DeleteUserDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
  public deleteUser(
    dto: DeleteUserDto,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<boolean>>;
  public deleteUser(
    dto: DeleteUserDto,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<boolean>>;
  public deleteUser(dto: DeleteUserDto, observe: any = 'body', reportProgress = false): Observable<any> {
    if (dto === null || dto === undefined) {
      throw new Error('Required parameter dto was null or undefined when calling deleteUser.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<boolean>(
      `${this.configService.getSettings('serverUrl')}/users/deleteUser`,
      dto,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * getUsers
   *
   * @param companyCode companyCode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUsers(
    companyCode: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<UserDto>>;
  public getUsers(
    companyCode: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<UserDto>>>;
  public getUsers(
    companyCode: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<UserDto>>>;
  public getUsers(companyCode: string, observe: any = 'body', reportProgress = false): Observable<any> {
    if (companyCode === null || companyCode === undefined) {
      throw new Error('Required parameter companyCode was null or undefined when calling getUsers.');
    }

    let queryParameters = new HttpParams();
    if (companyCode !== undefined) {
      queryParameters = queryParameters.set('companyCode', <any>companyCode);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient.get<Array<UserDto>>(`${this.configService.getSettings('serverUrl')}/users/`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  public getEditorUsers(companyCode: string, observe: any = 'body', reportProgress = false) {
    if (companyCode === null || companyCode === undefined) {
      throw new Error('Required parameter companyCode was null or undefined when calling getUsers.');
    }

    return this.authorizationService.hasPermission$('USER_READ').pipe(
      takeUntilDestroyed(this.destroyRef),
      switchMap((hasPermission) => {
        if (!hasPermission) {
          return of([] as Array<UserDto>);
        }

        let queryParameters = new HttpParams();
        if (companyCode !== undefined) {
          queryParameters = queryParameters.set('companyCode', <any>companyCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = ['application/json'];
        const httpHeaderAcceptSelected: string | undefined =
          this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];

        return this.httpClient.get<Array<UserDto>>(
          `${this.configService.getSettings('serverUrl')}/users/editors`,
          {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
          }
        );
      })
    );
  }

  /**
   * getMe
   *
   * @param companyCode companyCode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMe(observe?: 'body', reportProgress?: boolean): Observable<UserDto>;
  public getMe(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDto>>;
  public getMe(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDto>>;
  public getMe(observe: any = 'body', reportProgress = false): Observable<any> {
    const queryParameters = new HttpParams();

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient.get<Array<UserDto>>(`${this.configService.getSettings('serverUrl')}/users/me`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * getMe
   *
   * @param companyCode companyCode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUserSettings(observe?: 'body', reportProgress?: boolean): Observable<any> {
    const queryParameters = new HttpParams();

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient.get<any>(`${this.configService.getSettings('serverUrl')}/users/me/settings/bo`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * getMe
   *
   * @param companyCode companyCode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAdaptions(observe?: 'body', reportProgress?: boolean): Observable<any> {
    const queryParameters = new HttpParams();

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient.get<any>(
      `${this.configService.getSettings('serverUrl')}` + uri.uiAdaptionsByTenant,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * getMe
   *
   * @param companyCode companyCode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public putUserSettings(settings: any, observe?: 'body', reportProgress?: boolean): Observable<any> {
    const queryParameters = new HttpParams();

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    console.log('calling put');
    return this.httpClient.put<any>(
      `${this.configService.getSettings('serverUrl')}/users/me/settings/bo`,
      settings,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * updatePassword
   *
   * @param dto dto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePassword(
    dto: UpdatePasswordDto,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<boolean>;
  public updatePassword(
    dto: UpdatePasswordDto,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<boolean>>;
  public updatePassword(
    dto: UpdatePasswordDto,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<boolean>>;
  public updatePassword(
    dto: UpdatePasswordDto,
    observe: any = 'body',
    reportProgress = false
  ): Observable<any> {
    if (dto === null || dto === undefined) {
      throw new Error('Required parameter dto was null or undefined when calling updatePassword.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<boolean>(
      `${this.configService.getSettings('serverUrl')}/users/updatePassword`,
      dto,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * updateUser
   *
   * @param dto dto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateUser(
    dto: CreateOrUpdateUserDto,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<UserDto>;
  public updateUser(
    dto: CreateOrUpdateUserDto,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<UserDto>>;
  public updateUser(
    dto: CreateOrUpdateUserDto,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<UserDto>>;
  public updateUser(
    dto: CreateOrUpdateUserDto,
    observe: any = 'body',
    reportProgress = false
  ): Observable<any> {
    if (dto === null || dto === undefined) {
      throw new Error('Required parameter dto was null or undefined when calling updateUser.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<UserDto>(`${this.configService.getSettings('serverUrl')}/users/update`, dto, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * updateUser
   *
   * @param dto dto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePersonalDataAndPassword(
    dto: CreateOrUpdateUserDto,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<UserDto>;
  public updatePersonalDataAndPassword(
    dto: CreateOrUpdateUserDto,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<UserDto>>;
  public updatePersonalDataAndPassword(
    dto: CreateOrUpdateUserDto,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<UserDto>>;
  public updatePersonalDataAndPassword(
    dto: CreateOrUpdateUserDto,
    observe: any = 'body',
    reportProgress = false
  ): Observable<any> {
    if (dto === null || dto === undefined) {
      throw new Error('Required parameter dto was null or undefined when calling updateUser.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<UserDto>(
      `${this.configService.getSettings('serverUrl')}/users/update/contactDataAndPassword`,
      dto,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Check if a user can be safely deleted by checking dependencies
   *
   * @param userId The ID of the user to check
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public canDeleteUser(userId: number, observe: any = 'body', reportProgress = false): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined when calling canDeleteUser.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<any>(
      `${this.configService.getSettings('serverUrl')}/users/canDeleteUser/${userId}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Safely delete a user after checking dependencies
   *
   * @param userId The ID of the user to delete
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public safeDeleteUser(userId: number, observe: any = 'body', reportProgress = false): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined when calling safeDeleteUser.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.post<any>(
      `${this.configService.getSettings('serverUrl')}/users/safeDeleteUser/${userId}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}
